import { get_token } from "@/router";

function json_headers() {
  const headers = {};
  headers.Authorization = `Token ${get_token()}`;
  headers["Content-Type"] = "application/json";
  return headers;
}

export function request_organization_members(payload) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_organization_members/`,
      method: "POST",
      headers: json_headers(),
      data: JSON.stringify(payload),
      success: resolve,
      error: reject,
    });
  });
}

export function request_roles() {
  return new Promise((resolve) => {
    $.ajax({
      type: "GET",
      url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_roles/`,
      headers: {
        Authorization: `Token ${get_token()}`,
      },
      success: resolve,
    });
  });
}

// export function request_organization_positions(payload) {
//   return new Promise((resolve) => {
//     $.ajax({
//       type: "POST",
//       url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_organization_positions/`,
//       headers: json_headers(),
//       data: JSON.stringify(payload),
//       success: resolve,
//     });
//   });
// }

// export function request_organization_permissions(payload) {
//   return new Promise((resolve) => {
//     $.ajax({
//       type: "POST",
//       url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_organization_permissions/`,
//       headers: json_headers(),
//       data: JSON.stringify(payload),
//       success: resolve,
//     });
//   });
// }

export function request_invite_organization_member(payload) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "POST",
      url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/invite_organization_member/`,
      data: JSON.stringify(payload),
      headers: json_headers(),
      success: resolve,
      error: reject,
    });
  });
}

export function request_add_organization_member(payload) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "POST",
      url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/add_organization_member/`,
      data: JSON.stringify(payload),
      headers: json_headers(),
      success: resolve,
      error: reject,
    });
  });
}

export function request_bulk_add_organization_members(payload) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "POST",
      url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/bulk_add_organization_members/`,
      data: JSON.stringify(payload),
      headers: json_headers(),
      success: resolve,
      error: reject,
    });
  });
}

export function request_delete_organization_member(payload) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/delete_organization_member/`,
      method: "DELETE",
      headers: json_headers(),
      data: JSON.stringify(payload),
      success: resolve,
      error: reject,
    });
  });
}

export function request_assign_member_access(payload) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "POST",
      url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/assign_organization_member_access/`,
      headers: json_headers(),
      data: JSON.stringify(payload),
      success: resolve,
      error: reject,
    });
  });
}
